import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-707f373d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Schnellantwort", -1))
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_textarea = _resolveComponent("md-textarea")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_modal = _resolveComponent("md-modal")!

  return (_openBlock(), _createBlock(_component_md_modal, {
    ref: "modal",
    title: "Schnellantwort bearbeiten",
    icon: "bolt"
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Du kannst nur den Inhalt der Antwort bearbeiten. Wenn du auch den Namen bearbeiten möchtest, musst du eine neue Antwort erstellen. ")
    ]),
    body: _withCtx(() => [
      _hoisted_1,
      (_ctx.answer)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.answer.name), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_md_textarea, {
        variant: "outlined",
        modelValue: _ctx.message,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
        label: "Antwort",
        ref: "messageInput",
        validator: _ctx.messageValidator
      }, null, 8, ["modelValue", "validator"])
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Abbrechen")
        ]),
        _: 1
      }),
      _createVNode(_component_md_button, {
        variant: "filled",
        onClick: _ctx.updateAnswer
      }, {
        default: _withCtx(() => [
          _createTextVNode("Änderungen speichern")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 512))
}